
import React from "react";

const DeleteExamModal = ({ exam, handleDelete, closeModal }) => {
  console.log("DeleteExamModal props - exam:", exam); // Debug
  return (
    <div className="modal fade" id="delete_exam">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="fw-bold">Delete Exam</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              onClick={closeModal}
              aria-label="Close modal"
            />
          </div>
          <div className="modal-body">
            <p>
              Are you sure you want to delete the exam <strong>{exam?.title}</strong>?
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn bg-gray-100 rounded-pill mx-2"
              data-bs-dismiss="modal"
              onClick={closeModal}
              aria-label="Cancel"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger rounded-pill"
              onClick={() => {
                console.log("Confirm delete for exam:", exam); // Debug
                handleDelete();
              }}
              aria-label="Delete exam"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteExamModal;
